<template>
    <WindowLayout :title="title">
        <div class="row">
            <div class="col-sm-12">
                <div class="darmin card">
                    <div class="card-header pb-0 d-flex align-items-center">
                        <h5>{{ headerTitle }}</h5>
                    </div>
                    <div class="card-body theme-form">
                        <div class="row">
                            <div class="col">
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Nombre</label>
                                    <div class="col-sm-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="state.name"
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Titulo</label>
                                    <div class="col-sm-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="state.title"
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Especialidad</label>
                                    <div class="col-sm-9">
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="state.specialty"
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Plantilla</label>
                                    <div class="col-sm-9">
                                        <FileInput
                                            class="form-control"
                                            type="text"
                                            v-model="state.file"
                                            :file="state.file"
                                            :key="fileInput"
                                        />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label">Estado</label>
                                    <div class="col-sm-9">
                                        <SelectInputSimpleState v-model="state.status" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12" v-if="isReady">
                <DocumentDataManager v-model="state.data" />
            </div>
            <div class="col-sm-12">
                <div class="darmin card header-card">
                    <div class="row">
                        <div class="col-12 text-end">
                            <div
                                class="btn btn-primary ms-3 mb-1"
                                @click="handleAction('save')"
                                v-if="state.id"
                            >
                                <i class="far fa-save"></i>
                                Guardar
                            </div>
                            <div
                                v-if="!state.id"
                                class="btn btn-primary ms-3 mb-1"
                                @click="handleAction('create')"
                            >
                                <i class="far fa-save"></i>
                                Crear
                            </div>
                            <div
                                v-if="!state.id"
                                class="btn btn-primary ms-3 mb-1"
                                @click="handleAction('create_view')"
                            >
                                <i class="far fa-save"></i>
                                Crear y mostrar
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <pre v-if="env === 'development'">{{ JSON.stringify(state, null, 4) }}</pre>
    </WindowLayout>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { ref, onMounted } from 'vue';

// Components
import FileInput from '@/components/form/FileInput.vue';
import WindowLayout from '@/layouts/Window.layout.vue';
import SelectInputSimpleState from '@/components/form/SelectInputSimpleState.vue';
import DocumentDataManager from '@/modules/Care/Templates/components/DocumentDataManager.vue';

// Services
import useConsultaTemplate from './services/useConsultaTemplate';
import useConsultaTemplateForm from './services/useConsultaTemplateForm';

export default {
    name: 'ConsultaTemplateForm',
    components: {
        WindowLayout,
        SelectInputSimpleState,
        FileInput,
        DocumentDataManager,
    },
    props: {
        title: { type: String, default: 'Plantilla' },
        headerTitle: { type: String, default: 'Ingresar Plantilla' },
        item: Object,
    },
    setup(props) {
        const isReady = ref(false);

        const fileInput = ref(Date.now());

        const templateService = useConsultaTemplate();
        // eslint-disable-next-line object-curly-newline, operator-linebreak
        const { state, setState, v, handleAction, disabled } =
            useConsultaTemplateForm(templateService);

        /** ***** Helpers ***** */

        /** ***** Lifecycle Hooks ***** */
        onMounted(async () => {
            if (props.item) {
                await Promise.all([templateService.getConsultaTemplate(props.item.id)]);
                if (templateService.consultaTemplate.value) {
                    setState(templateService.consultaTemplate.value);
                }
            }
            isReady.value = true;
        });

        /** ***** Validator ***** */

        return {
            isReady,
            state,
            fileInput,
            disabled,
            v,
            handleAction,
            env: process.env.NODE_ENV,
        };
    },
};
</script>

<style scoped></style>
